import { render, staticRenderFns } from "./PeriodConditionLabel.vue?vue&type=template&id=2d7bec98&scoped=true"
import script from "./PeriodConditionLabel.vue?vue&type=script&lang=ts"
export * from "./PeriodConditionLabel.vue?vue&type=script&lang=ts"
import style0 from "./PeriodConditionLabel.vue?vue&type=style&index=0&id=2d7bec98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bec98",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/period.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FPeriodConditionLabel.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports